import * as React from 'react';
import ExternalLinkIcon from 'wix-ui-icons-common/ExternalLink';
import style from './SearchResultName.scss';
import { Heading, APPEARANCES } from '../../../../../PageElements/Heading';
import { TypeLabel } from '../../TypeLabel';
import { CustomLink } from '../../../../../PageElements/CustomLink';
import { ExternalLink } from '../../../../../PageElements/ExternalLink';

export const SearchResultName = ({
  name,
  onSearchResultClick,
  link,
  type,
  isExternalLink,
}) => {
  return (
    <div className={style.searchNameWrapper}>
      {isExternalLink ? (
        <ExternalLinkResult link={link} name={name} />
      ) : (
        <CurrentSiteLinkResult
          link={link}
          name={name}
          onSearchResultClick={onSearchResultClick}
        />
      )}
      <TypeLabel type={type} />
    </div>
  );
};

const ExternalLinkResult = ({ link, name }) => (
  <ExternalLink to={link} dataHook="external-link-result">
    <Heading
      className={style.title}
      appearance={APPEARANCES.H4}
      dataHook="result-name"
    >
      <span className={style.iconContainer}>
        <ExternalLinkIcon className={style.externalLinkIcon} />
      </span>
      {name}
    </Heading>
  </ExternalLink>
);

const CurrentSiteLinkResult = ({ link, name, onSearchResultClick }) => (
  <span data-hook="current-site-link-result" onClick={onSearchResultClick}>
    <CustomLink to={link}>
      <Heading
        className={style.title}
        appearance={APPEARANCES.H4}
        dataHook="result-name"
      >
        {name}
      </Heading>
    </CustomLink>
  </span>
);
